import { ToolOrderItemsStats } from '@bechtel/ht-types';
import { capitalize } from 'lodash';
import { useMemo } from 'react';

// Prepares an object like [ { toolType: 'Consumables', count: 9 } ... ] from tool order stats available from server
// and the grand total

export interface StatsRow {
  toolType: string;
  count: number;
}

export const useToolOrderStats = (toolOrderStats: ToolOrderItemsStats | undefined) => {
  const stats = useMemo(() => {
    if (!toolOrderStats) return [0, []];

    let total = 0;
    const statsRows = Object.keys(toolOrderStats)
      .filter((key) => key !== 'id' && key !== '__typename')
      .map((key) => {
        total += toolOrderStats[key];
        return { toolType: capitalize(key.replace('Count', '')), count: toolOrderStats[key] };
      });

    return [total, statsRows];
  }, [toolOrderStats]);

  return stats;
};
